import { Accessor, createContext, useContext } from 'solid-js';
import { SelectedEntityProperties } from '../models';
import { TrbLayer } from './design-package-interfaces';

export interface IDesignPackageContext {
  selectedProperties: Accessor<SelectedEntityProperties | undefined>;
  renderedDesignPackageLayers: Accessor<TrbLayer[]>;
  selectedTrbLayers: Accessor<TrbLayer[]>;
}

export const DesignPackageContext = createContext<IDesignPackageContext>();

export function useDesignPackage(): IDesignPackageContext {
  const context = useContext(DesignPackageContext);
  if (!context) {
    throw new Error(
      'useDesignPackage must be used within a DesignPackageProvider'
    );
  }
  return context;
}
